
import {
  computed,
  defineComponent, inject, PropType, reactive
} from 'vue'
import InfoButton from '@/components/Icons/InfoButton.vue'
import DimensionsIcon from '@/components/Icons/DimensionsIcon.vue'

export type HTMLInputType =
  'button'
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'submit'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week'


export default defineComponent({
  name: 'EditableBlockInput',
  components: { DimensionsIcon, InfoButton },
  props: {
    label: {
      type: String,
    },
    validate: {
      type: [String, Boolean],
      default: true,
      required: false
    },
    modelValue: {
      type: [String, Number, Array, Object],
      // required: true,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
    prepend: {
      type: String,
    },
    append: {
      type: String,
    },
    dimension: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<HTMLInputType>
    },
    step: {
      type: [String, Number]
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    tooltip: {
      type: String,
    },
    standalone: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean
    },
    warn: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    },
    inputAttrs: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:model-value'],
  setup (props, { emit }) {

    const inputState = reactive({
      label: computed(() => props.label),
      value: computed({ get: () => props.modelValue, set: (newValue) => emit('update:model-value', newValue) })
    })

    const editing = inject('editing', props.standalone)

    return {
      editing,
      inputState
    }
  }
})
